<template>
  <lb-dialog v-model="localSodWarningDialog" v-if="localSodWarningDialog" heading="Warning" width="45%" data-testid="access-management__sod-warning-dialog">
    <template v-slot:body>
      <div class="d-flex flex-column gap-4 pa-4" data-testid="access-management__sod-warning-content">
        <div class="d-flex gap-2">
          <img src="/img/icons/AlertIcon.svg" alt="Warning Icon" width="32" height="32" />
          <div class="d-flex flex-column gap-2">
            <h3 class="font-weight-semibold Warning">Warning-SOD</h3>
            <h5 class="Warning--text font-weight-medium">
              SOD is disabled for a few reporting units. Kindly submit a separate access request for the SOD disabled RU’s.
            </h5>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <div class="d-flex justify-end">
        <v-btn color="primary" @click="localSodWarningDialog = false" data-testid="access-management__sod-warning-ok-button">Confirm</v-btn>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'SodWarningDialog',
  props: {
    value: { type: Boolean, default: false }
  },
  computed: {
    localSodWarningDialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  }
}
</script>